import { TaskType } from "@common/types/task";
import { createActionSectionTrigger } from "@components/drawers/actionSectionTrigger";
import { Picker } from "@design-system/Picker/Picker.lib";
import type {
    PickerChevron,
    PickerTriggerElement,
} from "@design-system/Picker/Picker.types";
import { TASK_TYPE_LABEL } from "../closeTemplateTasksDrawer.constants";

interface LockedTaskTypePickerProps {
    taskType: TaskType;
    trigger?: PickerTriggerElement;
    chevron?: PickerChevron;
    triggerClassName?: string;
}

export const LockedTaskTypePicker = ({
    taskType,
    trigger,
    chevron,
    triggerClassName,
}: LockedTaskTypePickerProps) => (
    <Picker.Select
        items={[
            {
                value: taskType,
                label: TASK_TYPE_LABEL[taskType] ?? taskType,
            },
        ]}
        value={taskType}
        disabled
        chevron={chevron}
        trigger={trigger ?? createActionSectionTrigger(triggerClassName)}
    />
);
